import { Component, Vue, Prop } from 'vue-property-decorator';
import ContributionLevelIcon from '@/components/common/contribution-level-icon/ContributionLevelIcon.vue';
import { ContributionLevel } from '@/models';

@Component({
  components: {
    ContributionLevelIcon
  }
})
export default class NewLevelDialog extends Vue {
  @Prop() contributionLevel: ContributionLevel;
  @Prop() hideDialog: () => void;
}
